import React from "react";

// Reusable red-to-amber wave SVG. Width stretches full container.
export const RedWave = ({ className = "", strokeWidth = 1.5, opacity = 0.9 }) => (
  <svg
    viewBox="0 0 1200 60"
    preserveAspectRatio="none"
    className={className}
    aria-hidden="true"
  >
    <defs>
      <linearGradient id="fs-wave-grad" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#8B0000" stopOpacity="0" />
        <stop offset="20%" stopColor="#8B0000" stopOpacity="1" />
        <stop offset="50%" stopColor="#FF4500" stopOpacity="1" />
        <stop offset="80%" stopColor="#8B0000" stopOpacity="1" />
        <stop offset="100%" stopColor="#8B0000" stopOpacity="0" />
      </linearGradient>
      <linearGradient id="fs-wave-grad-2" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#8B0000" stopOpacity="0" />
        <stop offset="50%" stopColor="#B22222" stopOpacity="0.8" />
        <stop offset="100%" stopColor="#8B0000" stopOpacity="0" />
      </linearGradient>
    </defs>
    <path
      d="M 0 32 Q 200 4 400 32 T 800 32 T 1200 32"
      fill="none"
      stroke="url(#fs-wave-grad)"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      opacity={opacity}
    />
    <path
      d="M 0 40 Q 200 14 400 40 T 800 40 T 1200 40"
      fill="none"
      stroke="url(#fs-wave-grad-2)"
      strokeWidth={strokeWidth * 0.85}
      strokeLinecap="round"
      opacity={opacity * 0.7}
    />
  </svg>
);

export default RedWave;
